import ServiceCategoryPill from "../ServiceCategoryPill";

/** @deprecated Prefer ServiceCategoryPill — kept for My Vendors imports. */
export default function MyVendorServiceCategoryChip(props) {
  return <ServiceCategoryPill {...props} />;
}

/** Service pills row with optional overflow chip (manual-only card profile). */
export function MyVendorServiceCategoryRow({ services = [], maxVisible = 3 }) {
  if (!services.length) return null;
  const visible = services.slice(0, maxVisible);
  const overflow = services.length - maxVisible;

  return (
    <div className="flex flex-wrap items-center gap-1">
      {visible.map((service) => (
        <ServiceCategoryPill key={service} name={service} />
      ))}
      {overflow > 0 ? (
        <span className="inline-flex items-center rounded-md bg-gray-100 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-300">
          +{overflow} more
        </span>
      ) : null}
    </div>
  );
}
